const Vendor = {

    // FIELDS
    "name": "Name",
    "address": "Address",
    "postal_code": "Postal Code",
    "pan_no": "Pan Number",
    "tin_no": "Tin Number",
    "longitude": "Longitude",
    "latitude": "Latitude",
    "city": "City",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "vendor": "Vendor",

    // ERROR
    "error_name": "Enter Name",
    "error_address": "Enter Address",
    "error_postal_code": "Enter Postal Code",
    "error_pan_no": "Enter Pan Number",
    "error_tin_no": "Enter Tin Number",
    "error_longitude": "Enter Longitude",
    "error_latitude": "Enter Latitude",
    "error_city": "Select City",
    "error_status": "Select Status",
    "error_type_error": "Enter only Number",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_address": "ADDRESS",
    "table_city": "CITY",
    "table_status": "STATUS",

}

export default Vendor;
